import { FC, PropsWithChildren, useMemo } from 'react'

import CartContext, { CartContextState } from './cart.context'
import useCartContextHelper from './use-cart-context-helper'

const CartContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    addToCart,
    addMultipleToCart,
    removeLineItem,
    updateLineItem,
    isActionInProgress,
    errorMessage,
    setErrorMessage,
    isCartPopUpOpen,
    isB2BCartPopupOpen,
    setIsB2BCartPopupOpen,
    cartTotalItemsCount,
    newCheckout,
    lineItemDetailsByVariantId,
    isInitialized,
    isInitializing,
    isGoldBarInCart,
    setIsGoldBarInCart,
    isLoggedInUserEligbleForGoldBar,
    setIsCartPopUpOpen,
    giftCardSpidToSeenState,
    giftCardSpidToDeleteState,
    giftCardSpidToIsPresentInCard,
    updateGiftCardSpidToDelete,
    giftCardSpidToProductMap,
    refreshCheckout,
    onSwatchLinkClick,
    swatchData,
    addSwatchesToCart,
    removeSwatches,
    setSwatchData,
    swatchVariantDetailMap,
    buyNowCart,
    getMiniCheckoutForApplePay,
    isBuyNowInProgress,
    updateGiftingFlag,
    updateGiftingDetails,
    moveToSaveForLater,
    moveBackToCart,
    removeAllOutOfStockItems,
    recentlyAddedLineItemIds,
    refreshFulfillmentDetails,
    checkInDOBInformationAvailable,
    addBulkOrderCustomizationToCart,
    updateSubscription,
    b2bUpdateCustomizationLineItem,
  } = useCartContextHelper()
  const cartContextState = useMemo<CartContextState>(
    () => ({
      isInitialized: isInitialized,
      isActionInProgress,
      removeLineItem,
      updateLineItem,
      isInitializing,
      errorMessage,
      setErrorMessage,
      addToCart,
      isGoldBarInCart,
      setIsGoldBarInCart,
      isLoggedInUserEligbleForGoldBar,
      addMultipleToCart,
      newCheckout,
      lineItemDetailsByVariantId,
      isCartPopUpOpen,
      isB2BCartPopupOpen,
      setIsB2BCartPopupOpen,
      cartTotalItemsCount,
      setIsCartPopUpOpen,
      giftCardSpidToSeenState,
      giftCardSpidToDeleteState,
      giftCardSpidToIsPresentInCard,
      updateGiftCardSpidToDelete,
      giftCardSpidToProductMap,
      refreshCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      buyNowCart,
      getMiniCheckoutForApplePay,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
      removeAllOutOfStockItems,
      recentlyAddedLineItemIds,
      refreshFulfillmentDetails,
      checkInDOBInformationAvailable,
      addBulkOrderCustomizationToCart,
      updateSubscription,
      b2bUpdateCustomizationLineItem,
    }),
    [
      addToCart,
      addMultipleToCart,
      removeLineItem,
      updateLineItem,
      isActionInProgress,
      errorMessage,
      setErrorMessage,
      isCartPopUpOpen,
      isB2BCartPopupOpen,
      setIsB2BCartPopupOpen,
      isGoldBarInCart,
      setIsGoldBarInCart,
      cartTotalItemsCount,
      newCheckout,
      lineItemDetailsByVariantId,
      isInitialized,
      isInitializing,
      setIsCartPopUpOpen,
      giftCardSpidToSeenState,
      giftCardSpidToDeleteState,
      giftCardSpidToIsPresentInCard,
      updateGiftCardSpidToDelete,
      giftCardSpidToProductMap,
      refreshCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      isLoggedInUserEligbleForGoldBar,
      buyNowCart,
      getMiniCheckoutForApplePay,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
      removeAllOutOfStockItems,
      recentlyAddedLineItemIds,
      refreshFulfillmentDetails,
      checkInDOBInformationAvailable,
      addBulkOrderCustomizationToCart,
      updateSubscription,
      b2bUpdateCustomizationLineItem,
    ],
  )

  return <CartContext.Provider value={cartContextState}>{children}</CartContext.Provider>
}

export default CartContextProvider
